
import * as d3 from 'd3'
export default {
  methods: {

    summary_Overall(data) {
    
      this.donutCanvas = this.svg
      .append('g')
      .attr('transform', `translate(${this.summary.x + .5}, ${this.summary.y + .5})`)

      let chart = this.donutCanvas
      .append('g')
      .attr('transform', `translate(${-200}, ${100})`)

      chart
      .append('image')
      .attr('xlink:href', this.HOST + `/images/FPU/Overall_450.jpg`)
      .attr('x', -60).attr('y', -80).attr('width', 200)

      let summary = chart
      .append('g')
      .attr('transform', `translate(${-50}, ${130})`)

      summary
      .append('text')
      .attr('transform', `translate(-50, 0)`)
      .attr('font-size', 13).attr('fill', '#000')
      .text('Overall')

      summary
      .append('rect')
      .attr('x', -50).attr('y', 5).attr('rx', 3)
      .attr('width', 290).attr('height', 95)
      .attr('fill', 'none').attr('fill-opacity', .5)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      let y_ = 20
      this.summary.cols.forEach(d=> {
        summary
        .append('text')
        .attr('transform', `translate(${d.tx}, ${y_})`)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', d.align)
        .text(d.name)
      })
      y_ += 18

      this.summary.item.forEach(d=> {
        summary
        .append('text')
        .attr('transform', `translate(0, ${y_})`)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', 'end')
        .text(d.name)


        this.summary.cols.forEach(col=> {
          if(col.code == 'PRO') {
            let pro = data[`${d.code}_PRO`]
            summary
            .append('rect')
            .attr('x', col.sx).attr('y', y_ - 8.5)
            .attr('width', 100).attr('height', 11)
            .attr('fill', '#F4F5F5').attr('opacity', 1)

            summary
            .append('rect')
            .attr('x', col.sx).attr('y', y_ - 8.5)
            .attr('width', pro).attr('height', 11)
            .attr('fill', d.color).attr('opacity', 1)

            summary
            .append('text')
            .attr('x', pro< 70 ? col.sx+2 + pro : col.sx -2 + pro).attr('y', y_)
            .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', pro< 70 ? 'start' : 'end')
            .text(data[`${d.code}_${col.code}`] + '%')

          } else {
            summary
            .append('text')
            .attr('transform', `translate(${col.tx}, ${y_})`)
            .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
            .text(data[`${d.code}_${col.code}`])
            .call(this.call_Summary, col, data, d)
          }
        })

        y_ += 18
      })
    },


    summary_Area(st, data) {

      let chart = this.donutCanvas
      .append('g')
      .attr('transform', `translate(${200}, ${st.y})`)

      chart
      .append('image')
      .attr('xlink:href', this.HOST + `/images/FPU/${st.file.img}.jpg`)
      .attr('x', st.file.x).attr('y', st.file.y).attr('width', st.file.width)

      chart
      .append('text')
      .attr('transform', `translate(0, 0)`)
      .attr('font-size', 13).attr('fill', '#000')
      .text(st.code)

      chart
      .append('rect')
      .attr('x', 0).attr('y', 5).attr('rx', 3)
      .attr('width', 290).attr('height', 95)
      .attr('fill', 'none').attr('fill-opacity', .5)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      let summary = chart
      .append('g')
      .attr('transform', `translate(${50}, ${0})`)

      let y_ = 20
      this.summary.cols.forEach(d=> {
        summary
        .append('text')
        .attr('transform', `translate(${d.tx}, ${y_})`)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', d.align)
        .text(d.name)
      })
      y_ += 18

      this.summary.item.forEach(d=> {
        summary
        .append('text')
        .attr('transform', `translate(0, ${y_})`)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', 'end')
        .text(d.name)

        this.summary.cols.forEach(col=> {
          if(col.code == 'PRO') {
            let pro = data[`${d.code}_PRO`]
            summary
            .append('rect')
            .attr('x', col.sx).attr('y', y_ - 8.5)
            .attr('width', 100).attr('height', 11)
            .attr('fill', '#F4F5F5').attr('opacity', 1)

            summary
            .append('rect')
            .attr('x', col.sx).attr('y', y_ - 8.5)
            .attr('width', pro).attr('height', 11)
            .attr('fill', d.color).attr('opacity', 1)

            summary
            .append('text')
            .attr('x', pro< 70 ? col.sx+2 + pro : col.sx -2 + pro).attr('y', y_)
            .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', pro< 70 ? 'start' : 'end')
            .text(data[`${d.code}_${col.code}`] + '%')
            .text((col.code == 'PA' || col.code == 'PB') ? data_[`${col.code}_ACT`] : pro + '%');

          } else {
            summary
            .append('text')
            .attr('transform', `translate(${col.tx}, ${y_})`)
            .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
            .text(data[`${d.code}_${col.code}`])
            .call(this.call_Summary, col, data, d, st.code)
          }
          
        })
        y_ += 18
      })

    },

  }
}